import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated, isTokenExpired } from '../../util/authValidator';
import { hasSessionCookie } from '../../util/cookieHelper';
import { logOutUser } from '../../actions/authenticateActions';
import { connect } from 'react-redux';

const PrivateRouteComponent = ({ component: Component, dispatch, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        const authenticated = isAuthenticated();
        const hasSession = hasSessionCookie();
        const tokenExpired = isTokenExpired();

        // Check if user is authenticated via Redux OR cookie
        if (!authenticated && !hasSession) {
          // Not authenticated at all
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location }
              }}
            />
          );
        }

        // Check if token has expired
        if (authenticated && tokenExpired) {
          console.warn('Token expired, logging out...');
          dispatch(logOutUser());
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location, reason: 'expired' }
              }}
            />
          );
        }

        // All checks passed, render the component
        return <Component {...props} />;
      }}
    />
  );
};

export const PrivateRoute = connect()(PrivateRouteComponent);